import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';

export const HeaderEvents: AnalyticsBrandSettings = {

  // No esta Implementado
  headerPerfilUsuarioIniciarSesion(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'perfil_usuario', 'header', 'iniciar_sesion');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  headerCatalogoIrAlBuscador(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'header', 'ir_al_buscador');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  headerCheckoutIrACesta(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'checkout', 'header', 'ir_a_cesta');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  // No esta Implementado
  headerNavegacionVerCuenta(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'navegacion', 'header', 'ver_cuenta');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  headerPerfilUsuarioVerWishlist(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'perfil_usuario', 'header', 'ver_wishlist');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  headerNavegacionLogoOysho(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'navegacion', 'header', 'logo_oysho');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  // MOBILE
  headerNavegacionDesplegarMenu(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'navegacion', 'header', 'desplegar_menu');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  }

};
